
export default {
  name: 'CommonCard',
  props: {
    hovering: {
      type: Boolean,
      default: false,
    },
    // 手动设置固定容器固定高度
    height: {
      type: String,
      default: '89px',
    },
    //
    padding: { type: String, default: '' },
  },
  computed: {
    wrapHeight() {
      if (this.hovering) {
        const h = this.height.endsWith('px') ? this.height.slice(0, -2) : this.height
        return Number(h) + 54 + 'px'
      }
      return '100%'
    },
  },
}
